/* eslint-disable */
import { decodeDeviceCode, getType } from "@/utils/commonUtils";
class ShrimpTalk {
  constructor() {
    this._id = "";
    this.title = "";
    this.code = "";
    this.pond_id = "";
    this.shrimp_talk_id = "";
    this.main_pond_mother_id = "";
    this.pond_mothers = [];
    this.settings = {
      range: ["00:00", "00:01"],
      start_time: "00:00",
      end_time: "00:01",
      feed_limit: 0,
      feeding_level: 0,
    };
    this.status = "";
    this.user_id = "";
    this.created_at = "";
    this.updated_at = "";
  }

  castToSTObj(inputSTDetails) {
    const setValues = function(source, destination) {
      for (let key in source) {
        if (destination[key] === undefined) {
          destination[key] = {};
        }
        if (getType(source[key]) === "object") {
          setValues(source[key], destination[key]);
          continue;
        }
        destination[key] = source[key];
      }
    };
    setValues(inputSTDetails, this);
    this.v1_title = `ST${decodeDeviceCode(this.code)
      .toString()
      .padStart(5, "0")}`;
    this.main_pond_mother_id = (
      this.pond_mothers.filter((pm) => pm.is_master)[0] || { _id: 0 }
    )._id;
    this.settings.range = [this.settings.start_time, this.settings.end_time];
    this.shrimp_talk_id = this._id;
  }

  getSTPropertiesObj() {
    const propertyNameList = ["title", "pond_id", "shrimp_talks_id", "code"];
    const properties = {};
    propertyNameList.forEach((property) => {
      properties[property] = this[property];
    });
    return properties;
  }
  static v1Title(code) {
    return `ST${decodeDeviceCode(code)
      .toString()
      .padStart(5, "0")}`;
  }
}
export default ShrimpTalk;
